// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import accordion from "@flip/XDL/PreStyle/accordion";
import breadcrumbs from "@flip/XDL/PreStyle/breadcrumbs";
import breakpoints from "@flip/XDL/PreStyle/breakpoints";
import button from "@flip/XDL/PreStyle/button";
import checkbox from "@flip/XDL/PreStyle/checkbox";
import clickable from "@flip/XDL/PreStyle/clickable";
import colors from "@flip/XDL/PreStyle/colors";
import dataTable from "@flip/XDL/PreStyle/dataTable";
import datePicker from "@flip/XDL/PreStyle/datePicker";
import drawer from "@flip/XDL/PreStyle/drawer";
import dynamicDropdown from "@flip/XDL/PreStyle/dynamicDropdown";
import focus from "@flip/XDL/PreStyle/focus";
import formField from "@flip/XDL/PreStyle/formField";
import globalStyle from "@flip/XDL/PreStyle/globalStyle";
import header from "@flip/XDL/PreStyle/header";
import link from "@flip/XDL/PreStyle/link";
import loadingSpinner from "@flip/XDL/PreStyle/loadingSpinner";
import modal from "@flip/XDL/PreStyle/modal";
import overflowMenu from "@flip/XDL/PreStyle/overflowMenu";
import pagination from "@flip/XDL/PreStyle/pagination";
import panelMenu from "@flip/XDL/PreStyle/panelMenu";
import radio from "@flip/XDL/PreStyle/radio";
import select from "@flip/XDL/PreStyle/select";
import tab from "@flip/XDL/PreStyle/tab";
import tag from "@flip/XDL/PreStyle/tag";
import textArea from "@flip/XDL/PreStyle/textArea";
import textField from "@flip/XDL/PreStyle/textField";
import toast from "@flip/XDL/PreStyle/toast";
import tooltip from "@flip/XDL/PreStyle/tooltip";
import typography from "@flip/XDL/PreStyle/typography";
import zIndex from "@flip/XDL/PreStyle/zIndex";
import { xBaseTheme } from "@flip/XDL/types";

export default {
    breakpoints,
    colors,
    focus,
    // shadows,
    // transition,
    globalStyle,
    typography,
    zIndex,
    accordion,
    breadcrumbs,
    button,
    checkbox,
    clickable,
    dataTable,
    datePicker,
    drawer,
    dynamicDropdown,
    // fileUpload,
    header,
    formField,
    // fieldSet,
    // icon,
    // layoutTable,
    // layoutGroup,
    // layoutCell,
    link,
    // lists,
    // lazyImage,
    // loadingOverlay,
    loadingSpinner,
    // menu,
    modal,
    overflowMenu,
    pagination,
    panelMenu,
    radio,
    select,
    // swatch,
    tab,
    tag,
    // tagsField,
    textField,
    // tokenExFrame,
    textArea,
    toast,
    tooltip,
} as xBaseTheme;
